import {
  getStaffFilterDefaultValues,
  TStaffFilterValues,
} from "~/shared/hooks/useStaffFilterData/config";

export type TTrainingFilter = TStaffFilterValues;

export const getDefaultValues = (isRu: boolean): TTrainingFilter =>
  getStaffFilterDefaultValues(isRu);
